<template>
    <b-modal v-model="modalAberto" size="xl" @hidden="cancelar" button-size="md" hide-footer
        :title="prefix + ' > ' + title">
        <ReavaliacaoList :prefix="[prefix, title]" :ItemBemPermanente="ItemBemPermanente"></ReavaliacaoList>
    </b-modal>
</template>

<script>

import ReavaliacaoList from '@/modules/cadastros/reavaliacao/ReavaliacaoList.vue'

export default {
    name: "ModalReavaliacao",
    components: {
        ReavaliacaoList
    },
    props: {
        prefix: {
            tipe: String,
            default: "",
        },
        title: {
            tipe: String,
            default: "Reavaliação",
        },

        ItemBemPermanente: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            modalAberto: true,
        }
    },
    methods: {
        cancelar() {
            this.$emit('fecharModal')
        },

    }
}

</script>
